import React from 'react';
import { TriwordStore } from '../../TriwordStore';
import './ClueFragments.less';

const ClueFragments = () => {
  const {
    fragments,
    fragmentsWith1PositionRevealed: partiallyRevealed,
    fullWords,
    solved,
    revealed,
    usedPositionLifeline,
  } = TriwordStore.useState();

  return (
    <div className="clueFragmentsContainer">
      <div className={`flipper ${(solved || revealed) ? 'flipped' : ''}`}>
        <div className="front">
          <div className={`flipper ${usedPositionLifeline ? 'flipped' : ''}`}>
            <div className="front innerFront">
              {fragments[0]} <span className="largeSlash">/</span> {fragments[1]} <span className="largeSlash">/</span> {fragments[2]}
            </div>
            <div className="back innerBack">
              {partiallyRevealed[0]} <span className="largeSlash">/</span> {partiallyRevealed[1]} <span className="largeSlash">/</span> {partiallyRevealed[2]}
            </div>
          </div>
        </div>
        <div className="back">
          {fullWords[0]} / {fullWords[1]} / {fullWords[2]}
        </div>
      </div>
    </div>
  );
};

export default ClueFragments;